// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1KSRV","ranges":"BmiRanges_ranges__2T3xX"};